import { size, each } from 'lodash';
import validate from 'validate.js';

class Validation {
  constructor(constraint) {
    this.values = {};
    this.constraint = constraint;
  };
  hasErrors() {
    const errors = validate(this.values, this.constraint);
    if (errors && size(errors) ) {
      return true;
    }
    return false;
  };
  hasOnlyRequiredErrors() {
    const errors = validate(this.values, this.onlyRequired() );
    if (errors && size(errors) ) {
      return true;
    }
    return false;
  };
  errorMessages() {
    return validate(this.values, this.constraint);
  };
  onlyRequired() {
    const origConstraint = this.constraint;

    const simpleConstraint = {};
    each(origConstraint, (key, value) => {
      if (key.presence) {
        simpleConstraint[value] = {
          presence: true,
          length: { minimum: 1, },
        };
      }
    });
    if (size(simpleConstraint) ) {
      return simpleConstraint;
    }
    return origConstraint;
  };
  updateValues(values) {
    this.values = values;
  }
}

export default Validation;
